module.exports = __webpack_public_path__ + "img/b2.2ba231e.png";